import useCurrentRoute from './useCurrentRoute'
import useHistoryArray from './useHistoryArray'
import { watch } from 'vue'
import mitt from '@/plugins/mitt.js'

type useHistorySelectionOptions = {
  store?: any
}
/**
 * Persist recent selections in browser cache
 */
export default function useHistorySelection(opts: useHistorySelectionOptions) {
  // @ts-ignore
  const cache = (window._hcs = useHistoryArray({
    uniqueName: 'selection',
    maxItems: 10,
  }))

  watch(
    () => opts.store.state.search_module.validatedAt,
    async () => {
      const { name: routeName } = await useCurrentRoute()
      if (opts.store.getters['search_module/getSelectionLength'] === 0) {
        // FMA 20250131 resolve #47048 Problème Switch entre le module localisation et diagnostic
        return
      }
      await cache.pushToHistoryArray({
        routeName,
        activeSearchFormTabName:
          opts.store.state.search_module.activeSearchFormTabName,
        selectionLength: opts.store.getters['search_module/getSelectionLength'],
        ...opts.store.getters['search_module/getSelection'],
      })
      // @ts-ignore
      console.debugVerbose(6, 'UHS persist', routeName, {
        activeSearchFormTabName:
          opts.store.state.search_module.activeSearchFormTabName,
        selectionLength: opts.store.getters['search_module/getSelectionLength'],
        ...opts.store.getters['search_module/getSelection'],
      })
    }
  )

  return {
    async restoreLastSelection() {
      const { name: routeName } = await useCurrentRoute()
      const selection = await cache.getReverseFirstWhere(
        (obj) => obj.routeName === routeName
      )
      // @ts-ignore
      console.debugVerbose(6, 'UHS restore', {
        routeName,
        selection,
      })
      if (Object.keys(selection).length > 1) {
        opts.store.state.search_module.selectedVehiclesIds =
          selection.selectedVehiclesIds
        opts.store.state.search_module.selectedDriversIds =
          selection.selectedDriversIds
        opts.store.state.search_module.selectedCircuitsIds =
          selection.selectedCircuitsIds
        opts.store.state.search_module.selectedDateRanges =
          selection.selectedDateRanges
        opts.store.state.search_module.activeSearchFormTabName =
          selection.activeSearchFormTabName
        opts.store.commit(
          'search_module/updateLastSelectionMetadata',
          selection
        )
        mitt.emit('search_module/refresh')
      }
    },
  }
}
